import { Component, Input } from '@angular/core';

@Component({
  selector: 'sky-tooltip-badge[message]',
  template: `
    <sky-svg-icon
      class="ml-2 cursor-pointer text-sky-grey"
      icon="tooltip"
      [skyTooltip]="true"
      [tooltipLabel]="message"
    ></sky-svg-icon>
  `,
})
export class TooltipBadgeComponent {
  @Input() public message!: string;
}
